module.exports = __webpack_public_path__ + "97f2c2c2fff36296dbc343e658426183.png";